import { Navigate, Route } from '@tanstack/router'

import { casinoRoute } from '.'

export const casinoIndexRoute = new Route({
  getParentRoute: () => casinoRoute,
  path: '/',
  component: () => (
    <Navigate to="/casino/$category" params={{ category: 'lobby' }} />
  ),
})
